"use client";

import React, { useContext } from "react";
import "./Navbar.css";
import Link from "next/link"; // Update to use Next.js's Link component
import Hamburger from "hamburger-react";
import { UserContext } from "@/context/ContextProvider"; // Import the UserContext
import Image from "next/image";
import carIcon from "@/assets/Navbar/carIcon.svg";
import doorIcon from "../../assets/Navbar/doorIcon.svg";
import logo from "@/assets/Navbar/Logo.avif";
import { useRouter } from "next/navigation";
// Lazy Load the svgs
const NavChevron = React.lazy(() => import("@/assets/svgs/NavChevron"));
const LoginIcon = React.lazy(() => import("@/assets/svgs/LoginIcon"));

function Navbar({ isSidebarRightOpen, setIsSidebarRightOpen }) {
  const { userData } = useContext(UserContext); // Consume the context

  const router = useRouter();

  const firstLetter = (value) => String(value || "").trim().charAt(0).toUpperCase();
  const userInitials = (() => {
    const first = firstLetter(userData?.vorname);
    const last = firstLetter(userData?.nachname);
    if (first || last) return `${first}${last}`;
    const emailFirst = firstLetter(userData?.email);
    return emailFirst || ".";
  })();
  const userLabel =
    String(userData?.vorname || "").trim() ||
    String(userData?.email || "").split("@")[0] ||
    "Konto";

  const handleToggleRight = () => {
    setIsSidebarRightOpen((prev) => !prev);
  };

  const handleSignOut = () => router.push("/logout");

  // Mobile: Initialen führen direkt zur Account-Seite (früher: Konto-Sidebar).
  const handleAccountClick = () => router.push("/account");
  const handleLoginClick = () => router.push("/anmelden");

  return (
    <div className="navbar-container">
      <div className="header">
        <div className="mobile-nav-header">
          {userData ? (
            <button
              className="mobile-nav-account-button"
              onClick={handleAccountClick}
              type="button"
              aria-label="Zum Konto"
            >
              <p>{userInitials}</p>
            </button>
          ) : (
            <button
              type="button"
              onClick={handleLoginClick}
              aria-label="Anmelden"
              style={{
                background: "none",
                border: "none",
                padding: 0,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LoginIcon alt="login" className="account-login-logo" />
            </button>
          )}

          <Link href="/" passHref className="logo-image" aria-label="Startseite">
            <Image
              src={logo}
              alt="Autoeinfachlos logo"
              className="logo-image"
              width={200}
              height={22}
              sizes="(max-width: 768px) 160px, 200px"
              priority
              fetchPriority="high"
            />
          </Link>

          <Hamburger
            toggled={isSidebarRightOpen}
            className="mobile"
            toggle={handleToggleRight}
            size={20}
            label={isSidebarRightOpen ? "Navigation schließen" : "Navigation öffnen"}
          />
        </div>

        <div className="nav-header">
          <Link href="/" className="logo-image" aria-label="Startseite">
            <Image
              src={logo}
              alt="Autoeinfachlos logo"
              className="logo-image"
              width={200}
              height={22}
              sizes="(max-width: 768px) 160px, 200px"
              priority
              fetchPriority="high"
            />
          </Link>
          <nav className="navigation">
            <ul className="nav-links">
              <li>
                <Link href="/auto-bewerten" className="links">
                  Auto bewerten
                </Link>
              </li>
              <li>
                <Link href="/auto-verkaufen" className="links">
                  Auto verkaufen
                </Link>
              </li>

              <li>
                <Link href="/so-funktionierts" className="links">
                  So funktioniert’s
                </Link>
              </li>
              <li className="dropdown">
                <div className="dropdown-title-wrapper">
                  <div className="links ueber-uns-hoverlink">Service</div>
                  <NavChevron alt="chevron" className="nav-chevron" />
                </div>
                <ul className="dropdown-menu">
                  <Link
                    href="/auto-bewerten/listenpreis-auto"
                    className="dropdown-links"
                  >
                    <li className="transition">Listenpreis Auto</li>
                  </Link>
                  <Link
                    href="/fahrgestellnummer-pruefen"
                    className="dropdown-links"
                  >
                    <li className="transition">Fahrgestellnummer prüfen</li>
                  </Link>

                  <Link
                    href="/kaputtes-auto-verkaufen"
                    className="dropdown-links"
                  >
                    <li className="transition">Kaputtes Auto verkaufen</li>
                  </Link>
                </ul>
              </li>
              <li className="dropdown">
                <div className="dropdown-title-wrapper">
                  <div className="links ueber-uns-hoverlink">Über uns</div>
                  <NavChevron alt="chevron" className="nav-chevron" />
                </div>

                <ul className="dropdown-menu">
                  <Link href="/ueber-uns" className="dropdown-links">
                    <li className="transition">Über uns</li>
                  </Link>
                  <Link href="/ratgeber" className="dropdown-links">
                    <li className="transition">Ratgeber</li>
                  </Link>
                  <Link href="/faq" className="dropdown-links">
                    <li className="transition">Häufige Fragen</li>
                  </Link>

                  <Link href="/kontaktiere-uns" className="dropdown-links">
                    <li className="transition">Kontaktiere uns </li>
                  </Link>
                </ul>
              </li>

              {userData ? (
                <li className="dropdown">
                  <div className="dropdown-title-wrapper konto-dropdown">
                    <div className="links  mobile-nav-account-button">
                      <p>{userInitials}</p>
                    </div>

                    <p className="">{userLabel}</p>
                  </div>
                  <ul className="dropdown-menu">
                    <Link href="/account" className="dropdown-links ">
                      <li className="transition konto-item-wrapper">
                        <Image
                          src={carIcon}
                          alt="carIcon"
                          className="konto-dropdown-icon"
                        />

                        <span>Account</span>
                      </li>
                    </Link>

                    <div
                      className="dropdown-links"
                      onClick={() => handleSignOut()}
                    >
                      <li className="transition konto-item-wrapper">
                        <Image
                          src={doorIcon}
                          alt="signOut"
                          className="konto-dropdown-icon"
                        />

                        <span>Ausloggen</span>
                      </li>
                    </div>
                  </ul>
                </li>
              ) : (
                <>
                  <LoginIcon
                    alt="login"
                    className="account-login-logo"
                    aria-hidden="true"
                  />

                  <Link href="/anmelden" className="links">
                    Konto
                  </Link>
                </>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
